import { TIPOS_DE_FIGURINHA, type TipoDeFigurinha } from "@foto/shared";

/**
 * Como a tela chama cada tipo.
 *
 * O banco e a API dizem `texto`; na tela é "Letras". Quem opera pensa em "texto" como o que digita sobre a
 * foto (o título, a legenda), e aqui o tipo é outra coisa: palavras já **desenhadas**, uma imagem com
 * fundo transparente. "Letras" evita que alguém suba um título aqui achando que é a caixa de texto da folha.
 */
export const ROTULO_DO_TIPO: Record<TipoDeFigurinha, string> = {
  figurinha: "Figurinha",
  logo: "Logo",
  texto: "Letras",
};

export const ROTULO_DO_TIPO_NO_PLURAL: Record<TipoDeFigurinha, string> = {
  figurinha: "Figurinhas",
  logo: "Logos",
  texto: "Letras",
};

/** Uma linha que ajuda a escolher o tipo ao enviar: é a única decisão que não dá para desfazer sem reenviar. */
export const EXPLICACAO_DO_TIPO: Record<TipoDeFigurinha, string> = {
  figurinha: "Um desenho solto: coração, flor, estrela, selo.",
  logo: "A marca da casa, do grupo ou da vivência.",
  texto: "Palavras já desenhadas: um título ou uma frase em arte de letras.",
};

/** A aba "Todas" não é um tipo: o servidor recebe a ausência do filtro. */
export type FiltroDeTipo = TipoDeFigurinha | "todas";

export const ABAS_DE_TIPO: readonly { id: FiltroDeTipo; rotulo: string }[] = [
  { id: "todas", rotulo: "Todas" },
  ...TIPOS_DE_FIGURINHA.map((tipo) => ({ id: tipo, rotulo: ROTULO_DO_TIPO_NO_PLURAL[tipo] })),
];

/** O tipo que vai na consulta; `undefined` (sem filtro) para "Todas". */
export function tipoDoFiltro(filtro: FiltroDeTipo): TipoDeFigurinha | undefined {
  return filtro === "todas" ? undefined : filtro;
}
